<template>
    <div v-if="todisplay" v-show="isvisible" :style="sizeStyle" :class="{ 'mt-2': true, 'c-DropdownFileList': true, [`c-name-${name || 'unnamed'}`]: true }">
        <QInput ref="inputRef"
                v-model="inputValue"
                xstyle="styles"
                label="Select a file"
                prepend-icon="mdi-folder"
                :append-icon="menu ? 'mdi-menu-up' : 'mdi-menu-down'"
                :readonly="!menu"
                outlined
                dense
                hide-bottom-space
                autocomplete="off"
                @click="openMenu"
                @click:append.stop="handleAppendIconClick"
                @update:model-value="handleInput"
                @keydown.enter="handleEnter"
                @keydown.up.stop="navigateUp"
                @keydown.down.stop="navigateDown"
        ></QInput>
        <QMenu :close-on-content-click="false"
               :close-on-click="true"
               :target="inputTargetEl || true"
               anchor="bottom left"
               self="top left"
               max-height="400px"
               max-width="300px"
               :model-value="menu"
               @update:model-value="updateMenuState"
               @show="onMenuShow"
               :offset="[0, 4]">
            <QList dense>
                <QItem v-for="item in flatItems"
                       :key="item.path"
                       :ref="el => setItemRef(el, item)"
                       clickable
                       :class="`pad-${item.depth} q-ml-xs`"
                       :active="item.path === selectedPath"
                       active-class="bg-grey-3 text-dark"
                       @click="handleItemClick(item)">
                    <QItemSection avatar>
                        <QIcon :name="item.isFolder ? (expandedFolders.has(item.path) ? 'mdi-folder-open' : 'mdi-folder') : 'mdi-file-outline'" />
                    </QItemSection>
                    <QItemSection>
                        <QItemLabel>{{ item.name }}</QItemLabel>
                    </QItemSection>
                </QItem>
            </QList>
        </QMenu>
    </div>
</template>

<script>
    import { QInput, QMenu, QList, QItem, QItemSection, QItemLabel, QIcon } from 'quasar';
    import utils from '../../Shared/utils.jsx';
    import BaseComponent from './BaseComponentMixin.jsx';
    import careHelpfulFunctions from '../careHelpfulFunctions.jsx';

    export default {
        name: 'dropdown-filelist',
        mixins: [BaseComponent],
        components: {
            QInput, QMenu, QList, QItem, QItemSection, QItemLabel, QIcon,
        },
        data: function () {
            return {
                selectedPath: '',
                searchQuery: '',
                fileTree: {},
                expandedFolders: new Set(['/']),
                menu: false,
                isOpeningMenu: false,
                itemRefs: {}, // Store refs for list items

                sourceurlexpn: null,
                sourcerawexpn: null,
                selectedvalueexpn: null,
                labelexpn: null,

                selected_item: null,
                items: [],
                nameField: 'Name',
                valueField: 'Value',
                inputTargetEl: null,
            }
        },
        async created() {
            if (this.controlData.SourceType == 'URL' || (!this.controlData.SourceType && this.controlData.SourceURL))
                this.sourceurlexpn = utils.compile(this, this.controlData.SourceURL);

            if (this.controlData.SourceType == 'Raw')
                this.sourcerawexpn = utils.compileObject(this, this.controlData.Source);

            if (this.controlData.SelectedValue) {
                if (this.controlData.SelectedValue.startsWith('{#') || this.controlData.SelectedValue.startsWith('{%'))
                    this.selectedvalueexpn = utils.compileObject(this, this.controlData.SelectedValue);
                else
                    this.selectedvalueexpn = utils.compile(this, this.controlData.SelectedValue);
            }

            if (!this.controlData.FieldMappings.AutoSource) {
                let name = utils.compile(this, this.controlData.FieldMappings.Name);
                let value = utils.compile(this, this.controlData.FieldMappings.Value);

                this.nameField = (item) => {
                    this.sourceData = item;
                    return utils.evaluate(name, this);
                };
                this.valueField = (item) => {
                    this.sourceData = item;
                    return utils.evaluate(value, this);
                };
            }
            if (this.controlData.PublishField) {
                let vueSet = utils.helpers.convertSetValueToVueSet(this.controlData.PublishField, 'value');
                this.publishexpn = new Function('context', 'util', 'value', 'vue', `with (context) { ${vueSet} }`);
            }
        },
        //Mounted Replaced with preRenderComplete
        computed: {
            inputValue: {
                get() {
                    return this.menu ? this.searchQuery : this.selectedPath;
                },
                set(value) {
                    if (this.menu) {
                        this.searchQuery = value;
                    } else {
                        this.selectedPath = value;
                    }
                }
            },
            flatItems() {
                const items = []

                const traverse = (path, depth = 0) => {
                    if (!this.expandedFolders.has(path) && path !== '/') return

                    const folderContents = this.fileTree[path] || []
                    folderContents.forEach(item => {
                        items.push({ ...item, depth })
                        if (item.isFolder && this.expandedFolders.has(item.path)) {
                            traverse(item.path, depth + 1)
                        }
                    })
                }

                traverse('/')
                return items
            },
            fileItems() {
                return this.flatItems.filter(item => !item.isFolder)
            },

            label: function () {
                if (this.controlData.Label)
                    this.labelexpn = utils.compile(this, this.Translate(this.controlData.Label));

                if (this.labelexpn)
                    return utils.evaluate(this.labelexpn, this);
                else
                    return '';
            },
            styles: function () {
                return {
                    ...utils.resolveStyleHints(this.styleHints, this),
                };
            },
            sourceurlvalue: function () {
                if (this.sourceurlexpn)
                    return utils.evaluate(this.sourceurlexpn, this);
                else
                    return '';
            },
            sourcerawvalue: function () {
                if (this.sourcerawexpn)
                    return utils.evaluateObject(this.sourcerawexpn, this);
                else
                    return null;
            },
            selectedvalue: function () {
                if (this.selectedvalueexpn) {
                    if (this.controlData.SelectedValue.startsWith('{#') || this.controlData.SelectedValue.startsWith('{%'))
                        return utils.evaluateObject(this.selectedvalueexpn, this);
                    else
                        return utils.evaluate(this.selectedvalueexpn, this);
                }
                else
                    return null;
            },
            SelectedValue: function () {
                // This is the public accessor
                if (this.selected_item)
                    return this.getValue(this.selected_item);
                else
                    return null;
            }
        },
        methods: {
            async preRenderComplete() {
                this.fetchFolder('/');
                //await this.Refresh();
                this.finishRenderHandler(this);
            },
            async Refresh() {
                if (this.sourceurlvalue)
                    try {
                        this.items = await utils.api.get(this.sourceurlvalue);
                    }
                    catch (e) {
                        utils.warn(`DropdownList ${this.name} failed to retrieve SourceURL: ${this.controlData.SourceURL}`, e);
                    }

                if (this.sourcerawexpn)
                    this.items = this.sourcerawvalue;

                if (this.controlData.FieldMappings.AutoSource && this.items && this.items.length > 0) {
                    // Auto-detect name and value fields
                    const i0 = this.items[0];
                    if ('name' in i0) this.nameField = 'name';
                    else if ('Name' in i0) this.nameField = 'Name';
                    else if ('title' in i0) this.nameField = 'title';
                    else if ('Title' in i0) this.nameField = 'Title';
                    else {
                        const keys = Object.keys(i0);
                        const idx = keys.findIndex(k => typeof i0[k] === 'string');
                        this.nameField = idx >= 0 ? keys[idx] : 'name';
                    }

                    if ('value' in i0) this.valueField = 'value';
                    else if ('Value' in i0) this.valueField = 'Value';
                    else if ('id' in i0) this.valueField = 'id';
                    else if ('Id' in i0) this.valueField = 'Id';
                    else if ('ID' in i0) this.valueField = 'ID';
                    else {
                        const keys = Object.keys(i0);
                        const idx = keys.findIndex(k => k != this.nameField);
                        this.valueField = idx >= 0 ? keys[1] : nameField;
                    }
                }

                this.selected_item = this.items.find(item => this.getValue(item) === this.selectedvalue); // computed property
            },
            async sync(value) {
                if (typeof value === 'object')
                    console.log(`sync(object value:${JSON.stringify(value)})`);
                else
                    console.log(`sync(simple value:${value})`);

                this.selected_item = value;
                if (this.publishexpn)
                    this.publishexpn(this, careHelpfulFunctions, this.getValue(value), Vue);

                //let item = value; // this.items.find(item => this.getValue(item) === this.getValue(value));

                let name = this.getName(value);
                let itemv = this.getValue(value);
                let index = this.items.findIndex(item => this.getValue(item) === itemv);

                let actionData = {
                    Value: itemv,
                    SourceItem: {
                        Name: name,
                        Value: itemv,
                        SourceItem: {
                            Name: name,
                            Value: itemv,
                        },
                        SourceIndex: index
                    },
                    SourceIndex: index
                }

                await utils.executeAndCompileAllActions(this.controlData.Actions, actionData, this);

                if (typeof value === 'object')
                    utils.log(`DropdownList changed to: ${JSON.stringify(value)} (object)`);
                else
                    utils.log(`DropdownList changed to: ${value} (value)`);
            },
            getValue(item) {
                if (typeof this.valueField === 'function')
                    return this.valueField(item);
                else if (item)
                    return item[this.valueField];
                else
                    return null;
            },
            getName(item) {
                if (typeof this.nameField === 'function')
                    return this.nameField(item);
                else
                    return item[this.nameField];
            },

            getItemIndex(value) {
                return this.source.findIndex(item => this.getValue(item) === value);
            },

            async mockApi(path) {

                const files = await utils.api.get(`Apps/Projects${path}`, false, true);
                if (files)
                    return files.map(f => ({
                        name: f.FileNameNoPath,
                        path: '/' + f.FullNameWithPath,
                        isFolder: f.Type === 1,
                    }));

                // Simulate API delay
                await new Promise(resolve => setTimeout(resolve, 50))

                const mockData = {
                    '/': [
                        { name: 'Documents', path: '/Documents', isFolder: true },
                        { name: 'Images', path: '/Images', isFolder: true },
                        { name: 'readme.txt', path: '/readme.txt', isFolder: false }
                    ],
                    '/Documents': [
                        { name: 'Work', path: '/Documents/Work', isFolder: true },
                        { name: 'resume1.pdf', path: '/Documents/resume1.pdf', isFolder: false },
                        { name: 'resume2.pdf', path: '/Documents/resume2.pdf', isFolder: false },
                        { name: 'resume3.pdf', path: '/Documents/resume3.pdf', isFolder: false },
                        { name: 'resume4.pdf', path: '/Documents/resume4.pdf', isFolder: false },
                        { name: 'resume5.pdf', path: '/Documents/resume5.pdf', isFolder: false },
                        { name: 'resume6.pdf', path: '/Documents/resume6.pdf', isFolder: false },
                    ],
                    '/Documents/Work': [
                        { name: 'project1.docx', path: '/Documents/Work/project1.docx', isFolder: false },
                        { name: 'project2.docx', path: '/Documents/Work/project2.docx', isFolder: false },
                        { name: 'project3.docx', path: '/Documents/Work/project3.docx', isFolder: false },
                        { name: 'project4.docx', path: '/Documents/Work/project4.docx', isFolder: false },
                    ],
                    '/Images': [
                        { name: 'photo1.jpg', path: '/Images/photo1.jpg', isFolder: false },
                        { name: 'photo2.jpg', path: '/Images/photo2.jpg', isFolder: false },
                        { name: 'photo3.jpg', path: '/Images/photo3.jpg', isFolder: false },
                        { name: 'photo4.jpg', path: '/Images/photo4.jpg', isFolder: false },
                        { name: 'photo5.jpg', path: '/Images/photo5.jpg', isFolder: false },
                        { name: 'photo6.jpg', path: '/Images/photo6.jpg', isFolder: false },
                        { name: 'resume3.jpg', path: '/Images/resume3.jpg', isFolder: false },
                    ]
                }

                return mockData[path] || []
            },
            async fetchFolder(path) {
                if (!this.fileTree[path]) {
                    const contents = await this.mockApi(path)
                    this.fileTree[path] = contents.map(item => ({
                        ...item,
                        depth: path === '/' ? 0 : path.split('/').length
                    }));
                }
            },
            setItemRef(el, item) {
                if (el) {
                    this.itemRefs[item.path] = el;
                }
            },
            scrollSelectedIntoView() {
                if (!this.selectedPath) return;
                const selectedRef = this.itemRefs[this.selectedPath];
                const selectedEl = selectedRef?.$el || selectedRef;
                if (selectedEl?.scrollIntoView) {
                    selectedEl.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'start'
                    });
                }
            },
            onMenuShow() {
                this.$nextTick(() => this.scrollSelectedIntoView());
            },
            ensureParentFoldersExpanded() {
                if (!this.selectedPath || this.selectedPath === '/readme.txt') return

                const pathParts = this.selectedPath.split('/').filter(part => part)
                let currentPath = ''
                pathParts.forEach((part, index) => {
                    if (index === pathParts.length - 1) return // Skip the file itself
                    currentPath += `/${part}`
                    this.expandedFolders.add(currentPath)
                })
                this.expandedFolders = new Set(this.expandedFolders) // Trigger reactivity
            },
            async openMenu() {
                this.inputTargetEl = this.$refs.inputRef?.$el || this.inputTargetEl;
                this.isOpeningMenu = true
                this.itemRefs = {} // Clear previous refs
                this.ensureParentFoldersExpanded() // Ensure parent folders are expanded
                await this.$nextTick() // Wait for flatItems to update
                // Fetch any unvisited parent folders
                const promises = []
                if (this.selectedPath) {
                    const pathParts = this.selectedPath.split('/').filter(part => part)
                    let currentPath = ''
                    pathParts.forEach((part, index) => {
                        if (index === pathParts.length - 1) return // Skip the file itself
                        currentPath += `/${part}`
                        if (!this.fileTree[currentPath]) {
                            promises.push(this.fetchFolder(currentPath))
                        }
                    })
                }
                await Promise.all(promises)
                this.menu = true
                this.$nextTick(() => {
                    // QMenu content is teleported; @show provides the reliable timing for scroll.
                    this.scrollSelectedIntoView();
                })
            },
            updateMenuState(value) {
                console.log(`updateMenuState: ${value}, menu: ${this.menu}`);
                //return;

                if (!value && this.isOpeningMenu) {
                    console.log(`updateMenuState: setting isOpeningMenu false (A)`);
                    this.isOpeningMenu = false;
                    return;
                }
                if (this.menu != value) {
                    console.log(`updateMenuState: setting menu to ${value} (B)`);
                    this.menu = value;
                }

                console.log(`updateMenuState: setting isOpeningMenu false (C)`);
                this.isOpeningMenu = false;
            },
            handleAppendIconClick() {
                console.log(`handleAppendIconClick (this.menu:${this.menu})`);
                if (this.menu) {
                    this.menu = false; // Close menu if open
                }
                else {
                    this.openMenu() // Open menu if closed
                }
            },
            handleInput() {
                this.searchQuery = this.searchQuery || '';
                if (this.searchQuery.trim()) {
                    const query = this.searchQuery.toLowerCase();
                    const firstMatch = this.flatItems.find(item =>
                        !item.isFolder && item.name.toLowerCase().startsWith(query)
                    );
                    if (firstMatch) {
                        this.selectedPath = firstMatch.path;
                        this.$nextTick(() => {
                            this.scrollSelectedIntoView();
                        });
                    }
                }
            },
            handleEnter() {
                if (this.menu && this.selectedPath) {
                    this.searchQuery = this.flatItems.find(item => item.path === this.selectedPath)?.path || '';
                    this.menu = false; // Close menu on Enter
                }
            },
            navigateUp() {
                if (!this.menu || !this.fileItems.length) return
                const currentIndex = this.fileItems.findIndex(item => item.path === this.selectedPath)
                const nextIndex = currentIndex > 0 ? currentIndex - 1 : this.fileItems.length - 1
                this.selectedPath = this.fileItems[nextIndex].path
                this.searchQuery = this.fileItems[nextIndex].name // Sync searchQuery with selected item name
                this.$nextTick(() => {
                    this.scrollSelectedIntoView();
                })
            },
            navigateDown() {
                if (!this.menu || !this.fileItems.length) return
                const currentIndex = this.fileItems.findIndex(item => item.path === this.selectedPath)
                const nextIndex = currentIndex < this.fileItems.length - 1 ? currentIndex + 1 : 0
                this.selectedPath = this.fileItems[nextIndex].path
                this.searchQuery = this.fileItems[nextIndex].name // Sync searchQuery with selected item name
                this.$nextTick(() => {
                    this.scrollSelectedIntoView();
                })
            },
            async handleItemClick(item) {
                if (item.isFolder) {
                    if (this.expandedFolders.has(item.path)) {
                        // Collapse folder
                        this.expandedFolders.delete(item.path);
                        this.expandedFolders = new Set(this.expandedFolders) // Trigger reactivity
                        this.$nextTick(() => {
                            this.menu = true; // Keep menu open
                        });
                    }
                    else {
                        this.expandedFolders.add(item.path);
                        await this.fetchFolder(item.path);
                        this.expandedFolders = new Set(this.expandedFolders); // Trigger reactivity
                        // Ensure menu stays open
                        this.$nextTick(() => {
                            this.menu = true;
                        })
                    }
                }
                else {
                    this.selectedPath = item.path;
                    this.searchQuery = item.path;
                    this.menu = false; // Close dropdown on file selection
                }
            },
        },
        props: {
        },
    };
</script>

<style scoped>
    /* Ensure single-line items */
    .q-item {
        min-height: 36px !important;
    }

    .q-item__label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .pad-0 {
        padding-left: 0rem !important;
    }
    .pad-1 {
        padding-left: 1rem !important;
    }
    .pad-2 {
        padding-left: 2rem !important;
    }
    .pad-3 {
        padding-left: 3rem !important;
    }
    .pad-4 {
        padding-left: 4rem !important;
    }
    .pad-5 {
        padding-left: 5rem !important;
    }
    .pad-6 {
        padding-left: 5rem !important;
    }
    .pad-7 {
        padding-left: 5rem !important;
    }
    .pad-8 {
        padding-left: 5rem !important;
    }
    .pad-9 {
        padding-left: 5rem !important;
    }
    /* Spinning animation for append icon */
    .q-field__append i {
        transition: transform 0.3s ease-in-out;
    }

    .q-field__append .mdi-menu-up {
        transform: rotate(360deg);
    }

    .q-field__append .mdi-menu-down {
        transform: rotate(0deg);
    }
</style>